export default {
  root: {
    borderRadius: '4px',
    backgroundColor: 'action.selected',
    margin: 1,
    marginTop: 0,
    paddingTop: '2px',
    paddingBottom: '2px',
    paddingLeft: '10px',
    paddingRight: '12px',
    '&:hover': {
      backgroundColor: 'action.hover'
    },
    '& .MuiListItemIcon-root': {
      minWidth: 0,
      color: 'action.active'
    },
    '& svg': {
      fontSize: '1.2rem',
      color: 'action.active'
    },
    '& .MuiListItemText-primary': {
      fontSize: 14,
      fontWeight: 500,
      marginLeft: '14px',
      marginRight: '14px',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden'
    }
  },
  developmentKg: {
    backgroundColor: '#ff98002e' // Light orange background (10% opacity)
  },
  mainKg: {
    // Use default background - no special styling for main branches
  },
  gitIcon: {
    width: '18px',
    height: '18px',
    minWidth: 'auto'
  },
  developmentIcon: {
    color: '#9b5d00 !important' // Custom orange for dev
  },
  mainIcon: {
    // Use default icon color for main branches
  },
  mainBranchText: {
    // Use default text color for main branches
  },
  devBranchText: {
    color: '#9b5d00 !important'
  },
  developmentArrow: {
    color: '#9b5d00 !important',
    width: '18px',
    height: '18px'
  },
  mainArrow: {
    // Use default arrow color for main branches
    width: '18px',
    height: '18px'
  },
  dialog: {
    '& .MuiDialogTitle-root .MuiButton-root': {
      float: 'right'
    },
    '& .MuiListItemText-root': {
      marginLeft: 1
    }
  }
};
